import {useSearchParams} from 'react-router-dom'
import ConnectorViewForm from '../../../../antd/connector_views/ConnectorViewForm'

const ConnectorViewNew = () => {
  const [searchParams] = useSearchParams()

  return (
    <ConnectorViewForm
      persisted={false}
      clone_from={searchParams.get('clone_from') ? true : false}
    />
  )
}

export default ConnectorViewNew
